@if (image()) {
  <div class="flex flex-col pt-5">
    @if (!thumbLoaded()) {
      <p-skeleton height="30rem" />
    }

    @if (config.data.useAuthImagePipe) {
      <img
        class="transition-[10s] w-full"
        [src]="getThumbLink(image()._id) | useHttpImgSrc"
        (load)="thumbLoaded.set(true)"
        [style.opacity]="thumbLoaded() ? '1' : '0'"
        [style.display]="fullLoaded() ? 'none' : 'block'"
      />
      <img
        class="w-full"
        [src]="getImageLink(image()._id) | useHttpImgSrc"
        (load)="fullLoaded.set(true)"
        [style.opacity]="fullLoaded() ? '1' : '0'"
        [style.height]="fullLoaded() ? undefined : '0'"
      />
    } @else {
      <img
        class="transition-[10s] w-full"
        [src]="getThumbLink(image()._id)"
        (load)="thumbLoaded.set(true)"
        [style.opacity]="thumbLoaded() ? '1' : '0'"
        [style.display]="fullLoaded() ? 'none' : 'block'"
      />
      <img
        class="w-full"
        [src]="getImageLink(image()._id)"
        (load)="fullLoaded.set(true)"
        [style.opacity]="fullLoaded() ? '1' : '0'"
        [style.height]="fullLoaded() ? undefined : '0'"
      />
    }

    <span class="text-xl font-bold mt-4">{{ image().title }}</span>
    <span class="whitespace-pre-wrap mt-4 text-muted-color">{{ image().description }}</span>
  </div>
}

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
</div>
